import React from "react";
import {
  ProjectIcon,
  NotificationIcon,
  UserProfileIcon,
  RecentIcon,
  StarredIcon,
  DiscoverIcon,
  StatusUpdatesIcon,
  NavigationItem,
  NavItem,
} from "@kxd/ui";

interface AppNavigationProps {
  activeItem?: string;
}

const AppNavigation: React.FC<AppNavigationProps> = ({
  activeItem = "For you",
}) => {
  // Navigation is handled by NavigationItem component with ROUTE_MAP
  // No need for handleItemClick - component handles it automatically

  const navigationItems: NavItem[] = [
    {
      icon: <UserProfileIcon />,
      label: "For you",
      alt: "For you - Personalized dashboard",
      path: "/home",
    },
    {
      icon: <RecentIcon />,
      label: "Recent",
      alt: "Recent - View recent projects",
      path: "/home/recent",
    },
    {
      icon: <StarredIcon />,
      label: "Starred",
      alt: "Starred - View starred projects",
      path: "/home/starred",
    },
    {
      icon: <DiscoverIcon />,
      label: "Discover",
      alt: "Discover - Explore platform capabilities",
      path: "/home/discover",
    },
    {
      icon: <NotificationIcon />,
      label: "Notifications",
      alt: "Notifications - View updates and alerts",
      path: "/home/notifications",
    },
    {
      icon: <StatusUpdatesIcon />,
      label: "Status updates",
      alt: "Status updates - Project status information",
      path: "/home/status-updates",
    },
    {
      icon: <ProjectIcon />,
      label: "Projects",
      alt: "Projects - Manage projects",
      path: "/home/projects",
    },
  ];

  return (
    <>
      {navigationItems.map((item, index) => (
        <NavigationItem key={index} item={item} activeItem={activeItem} />
      ))}
    </>
  );
};

export default AppNavigation;
